import { SalesReportVariant } from '../enums/salesReportVariant'

export const DEFAULT_SALES_REPORT_VARIANT = SalesReportVariant.Overview
